var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndiqueGanhe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "84.000000pt",
    height: "90.000000pt",
    viewBox: "0 0 84.000000 90.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,90.000000) scale(0.100000,-0.100000)",
    fill: "#A51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312 881 c-100 -35 -156 -114 -156 -221 0 -253 327 -330 447 -105 30 56 29 155 0 211 -30 57 -83 100 -145 119 -65 19 -81 19 -146 -4z m168 -72 c79 -44 110 -142 70 -224 -32 -66 -87 -100 -160 -100 -73 0 -128 34 -160 100 -75 156 97 309 250 224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 326 c-68 -25 -79 -32 -136 -85 -69 -64 -119 -200 -84 -229 25 -21 44 -4 51 47 7 54 50 129 92 158 87 61 111 68 249 68 l130 1 0 24 c0 31 -24 38 -145 38 -76 1 -108 -4 -157 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 240 l0 -50 -50 0 c-49 0 -50 -1 -50 -30 0 -29 1 -30 50 -30 l50 0 0 -50 c0 -49 1 -50 30 -50 29 0 30 1 30 50 l0 50 50 0 c49 0 50 1 50 30 0 29 -1 30 -50 30 l-50 0 0 50 c0 49 -1 50 -30 50 -29 0 -30 -1 -30 -50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiqueGanhe);
export default __webpack_public_path__ + "static/media/indique_ganhe.dafb3800b269ed8f5f54dc786059b601.svg";
export { ForwardRef as ReactComponent };